import { MouseEvent } from "react"
import { cn } from "cn"

import { selectIsSplitView } from "@/lib/storage/app-slice"
import {
  navigateToHistoryIndexThunk,
  selectDetailSheetCanGoBack,
  selectDetailSheetHistory,
} from "@/lib/storage/detail-sheet-slice"
import { useAppDispatch, useAppSelector } from "@/lib/storage/hooks"
import IconChevronLeft from "@/components/icons/chevron-left"
import { IconButton } from "./ui/icon-button"

export function DetailSheetHistoryNav({ overlay }: { overlay?: boolean }) {
  const dispatch = useAppDispatch()
  const history = useAppSelector(selectDetailSheetHistory)
  const detailSheetCanGoBack = useAppSelector(selectDetailSheetCanGoBack)
  const isSplitView = useAppSelector(selectIsSplitView)

  const handleBack = (event: MouseEvent) => {
    event.stopPropagation()
    if (detailSheetCanGoBack) {
      void dispatch(navigateToHistoryIndexThunk(history.currentIndex - 1))
    }
  }

  return (
    detailSheetCanGoBack && (
      <div className={cn("self-center", !isSplitView && !overlay && "-ml-1.5")}>
        <IconButton
          variant={overlay ? "overlay" : "ghost"}
          icon={IconChevronLeft}
          label="Back"
          tooltip
          onClick={handleBack}
        />
      </div>
    )
  )
}
